export default __webpack_public_path__ + "static/media/camera.9bcd8deb.svg";